// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCvWbKkeDQlqqzPzfNJKerlgjEGIfO_6pg",
  authDomain: "elcovia-a8c37.firebaseapp.com",
  projectId: "elcovia-a8c37",
  storageBucket: "elcovia-a8c37.appspot.com",
  messagingSenderId: "549190271260",
  appId: "1:549190271260:web:1d8334c3aa65b57fc83ad9",
  measurementId: "G-W7X00R8C7H"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const firestore = getFirestore(app);

export { app, analytics, auth, firestore };